// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Csgv","title":"InfoRow_title__2JFbK"};